import React, { useEffect, useState } from "react";
import ShareAndFindItem from "./ShareAndFindItem";
import "./ShareAndFind.css";
// import HomeSquare from "../../../images/Product/homesSquare.jpg";
// import VehiclesSquare from "../../../images/Product/CarsSquare.jpg";
// import WorkspaceSquare from "../../../images/Product/officeSquare.jpg";
// import RVsSquare from "../../../images/Product/RVSSquare.jpg";
// import BoatsSquare from "../../../images/Product/BoatsSquare.jpg";
// import BikesSquare from "../../../images/Product/BikesSquare.jpg";
// import ElectronicsSquare from "../../../images/Product/ElectronincsSquare.jpg";
// import FilmSquare from "../../../images/Product/filmingSquare.jpg";
// import EventSquare from "../../../images/Product/eventSquare.jpg";
// import PowerTools from "../../../images/Product/powerToolsSquare.jpg";
// import EventEquipment from "../../../images/Product/eventEquipmentSquare.jpg";
// import ParkingSquare from "../../../images/Product/ParkingSquare.jpg";
import headerBg from "../../../images/header-bg.png";

import Location from "../Location/Location";
import { Fade } from "react-reveal";

const ShareAndFind = () => {
  const [category, setCategory] = useState([]);
  useEffect(() => {
    fetch("./Category.json")
      .then((res) => res.json())
      .then((data) => setCategory(data));
  }, []);
  console.log(category);
  return (
    <div className="shareandfind mt-5">
      <div className="container">
        <div className="main_title">
          <Fade left>
            <h1 className="sectionHeader111 pb-3">
              <span className="text-yellow">Don't Buy We share </span>
              <span className="text-blue">
                {" "}
                Anything Anywhere{" "}
                <span className="headerPsudo22">
                  <img src={headerBg} alt="" />
                </span>
              </span>
            </h1>
          </Fade>
          <span className="headerPsudoText22">
            <span className="p">
              Save money, do more, get more! a sustainable lifestyle!
            </span>
          </span>
        </div>
        <div className="row shareandfind-row w-100">
          {/* <h1 className="sectionHeader  py-3">
            <span className="text-yellow">Don't Buy We share </span>
            <span className="text-blue " style={{ position: "relative" }}>
              {" "}
              Anything Anywhere
              <span className="headerPsudo">
                <img src={headerBg} alt="" />
              </span>
              <span className="headerPsudoText">
                <span className="p">
                  Save money, do more, get more! a sustainable lifestyle!
                </span>
              </span>
            </span>
          </h1> */}
          {/* <ShareAndFindItem
            title="Vacation Home"
            example="Short & Long Term Rental"
            img={HomeSquare}
          />
          <ShareAndFindItem
            title="Events Space"
            example="We SHare, Wedding Halls, Receptions & Equipment"
            img={EventSquare}
          />
          <ShareAndFindItem
            title="Workspace"
            example="Offices & Conference Rooms"
            img={WorkspaceSquare}
          />
          <ShareAndFindItem
            title="Vehicles"
            example="Cars, Vans Work Vehicles"
            img={VehiclesSquare}
          />
          <ShareAndFindItem
            title="RVs"
            example="Sport and Champing equipment"
            img={RVsSquare}
          />
          <ShareAndFindItem
            title="Boats"
            example="Yachts, Sailboats, speedboats"
            img={BoatsSquare}
          />
          <ShareAndFindItem
            title="Bikes"
            example="Scooters, mountain bikes & road bikes"
            img={BikesSquare}
          />
          <ShareAndFindItem
            title="Electronics"
            example="Drones, Projectors, Music Inst. DJ equip. etc."
            img={ElectronicsSquare}
          />
          <ShareAndFindItem
            title="Power Tools"
            example="Carpentry, Construction, Landscaping, etc"
            img={PowerTools}
          />
          <ShareAndFindItem
            title="Film Equipment"
            example="Still and Video Cameras, equipment and accessories"
            img={FilmSquare}
          />
          <ShareAndFindItem
            title="Event Equipment"
            example="Sound, Lighting and Video"
            img={EventEquipment}
          />
          <ShareAndFindItem
            title="Parking"
            example="in-door & out-door Garages, Storge, Warehouses"
            img={ParkingSquare}
          /> */}
          {category.map((item) => (
            <ShareAndFindItem item={item} key={item.id} />
          ))}
        </div>
      </div>
      <Location />
    </div>
  );
};

export default ShareAndFind;
